import React from 'react';

import {
  Typography
} from '@material-ui/core';
import { Grid } from '@mui/material';
import { classes } from '../../components/Map/classes';
import { SatisfactionMapContext } from '../../contexts/SatisfactionMapFilterContext';
import Neighborhood from '../../components/Map/Filters/Neighborhood';
import Area from '../../components/Map/Filters/Area';
import Group from '../../components/Map/Filters/Group';
import State from '../../components/Map/Filters/State';
import Late from '../../components/Map/Filters/Late';
import Period from '../../components/Map/Filters/Period';
import Target from '../../components/Map/Filters/Target';
import Evaluation from '../../components/Map/Filters/Evaluation';

export default function SatisfactionFilters() {

  return (
    <div className="filtros-mapa">
      <Typography variant="h5" align="center" style={classes.textTitle}>
        Ocorrências Comuns
      </Typography>

      <div id='filters-grid'>
        <Grid container spacing={2} justifyContent='center'>
          <Grid item xs={12} sm={6} md={6} lg={4} xl={3}>
            <Neighborhood context={SatisfactionMapContext} />
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={4} xl={3}>
            <Area context={SatisfactionMapContext} />
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={4} xl={3}>
            <Group context={SatisfactionMapContext} />
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={4} xl={3}>
            <State context={SatisfactionMapContext} /> 
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={4} xl={3}>
            <Late context={SatisfactionMapContext} /> 
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={4} xl={3}>
            <Period context={SatisfactionMapContext} /> 
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={4} xl={3}>
            <Target context={SatisfactionMapContext} /> 
          </Grid>
          
          <Grid item xs={12} sm={12} md={6} lg={4} xl={3}>
            <Evaluation context={SatisfactionMapContext} /> 
          </Grid>
        </Grid>
      </div>
    </div >
  )
}